<div class="sw-in-app-purchase-checkout-subscription-change">
    <div class="sw-in-app-purchase-checkout-subscription-change__item">
        <p class="sw-in-app-purchase-checkout-subscription-change__plan-name">
            {{ $t('sw-in-app-purchase-checkout-subscription-change.current-plan') }}
            <span class="sw-in-app-purchase-checkout-subscription-change__current-plan">({{ currentPlanName }})</span>
        </p>
        <p class="sw-in-app-purchase-checkout-subscription-change__plan-price">
            <template v-if="isIncludedInPluginLicense">
                {{ $t('sw-in-app-purchase-checkout-subscription-change.free') }}
            </template>
            <template v-else>
                {{ currentPrice }}*
                <template v-if="currentPlanDuration">
                    /{{ currentPlanDuration }}
                </template>
            </template>
        </p>
    </div>
    <div class="sw-in-app-purchase-checkout-subscription-change__item">
        <p class="sw-in-app-purchase-checkout-subscription-change__plan-name">
            {{ $t('sw-in-app-purchase-checkout-subscription-change.new-plan') }}
            <span class="sw-in-app-purchase-checkout-subscription-change__new-plan">({{ newPlanName }})</span>
        </p>
        <p class="sw-in-app-purchase-checkout-subscription-change__plan-price">
            {{ currencyFilter(cart.netPrice, 'EUR', 2) }}*
            <template v-if="newPlanDuration">
                /{{ newPlanDuration }}
            </template>
        </p>
    </div>

    <div class="sw-in-app-purchase-checkout-subscription-change__divider" />

    <div class="sw-in-app-purchase-checkout-subscription-change__item">
        <p class="sw-in-app-purchase-checkout-subscription-change__due-day">
            {{ $t('sw-in-app-purchase-checkout-subscription-change.due-today') }}
        </p>
        <p class="sw-in-app-purchase-checkout-subscription-change__due-day">
            {{ proratedNetPrice }}*
        </p>
    </div>

    <p v-if="infoHint" class="sw-in-app-purchase-checkout-subscription-change__info-hint">
        {{ infoHint }}
    </p>

    <mt-banner
        v-if="isIncludedInPluginLicense"
        variant="attention"
        :show-icon="true"
        class="sw-in-app-purchase-checkout-subscription-change__access-grant-hint"
    >
        <strong>{{ $t('sw-in-app-purchase-checkout-subscription-change.attention') }}</strong>
        <span>
            {{ $t('sw-in-app-purchase-checkout-subscription-change.access-grant-hint', { plan: currentPlanName }) }}
        </span>
    </mt-banner>
</div>
